import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { Suspense, lazy } from 'preact/compat';
const RadioGroup = lazy(
    () => import(/* webpackChunkName: "radio-group" */ '../../shared/form/radio-group')
);

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.upc != this.props.upc) {
            return true;
        }

        if (nextProps.packages != this.props.packages) {
            return true;
        }

        if (nextProps.submitting != this.props.submitting) {
            return true;
        }

        return false;
    }

    render({ packages, kc_sale, submitting }) {
        if (packages) {
            return (
                <kc-store className={kc_sale ? 'sale' : ''}>
                    <kc-key>
                        <p>SAVINGS</p>
                        <p className={kc_sale ? 'sale' : ''}>TOTAL</p>
                        <p>SELECTED<br />PACKAGE</p>
                    </kc-key>
                    <kc-packages>
                        <row className='is-aligned-end'>
                            {packages.map(this.renderPackage)}
                        </row>
                    </kc-packages>
                    <row className='has-margin-30-bottom has-margin-40-top'>
                        <column className='is-12 has-text-center kc-total'>
                            <h3>Order Total</h3>
                            {this.renderTotal()}
                        </column>
                    </row>
                    <row>
                        <column className='is-12 has-text-center'>
                            <button
                                className='button-havelock-blue'
                                onClick={this.purchase}
                            >
                                {submitting ? 'SUBMITTING…' : 'PURCHASE COINS'}
                            </button>
                        </column>
                    </row>
                </kc-store>
            );
        }

        return (<kc-store />);
    }

    renderPackage = (pkg) => {
        const biggest = 'karmacoin-package-2000';
        const popular = 'karmacoin-package-570';
        const pkgClass = pkg.upc == biggest ? 'biggest' : (pkg.upc == popular ? 'popular' : '');

        return (
            <column className={`has-text-center ${pkgClass}`}>
                <kc-package
                    onClick={e => this.selectPackage(e, pkg.upc)}
                    className={pkg.upc == this.props.upc ? 'active' : ''}
                >
                    <kc-package-header>
                        <h2>{pkg.free_kcs + pkg.paid_kcs}</h2>
                        <p>Coins</p>
                    </kc-package-header>
                    <p>{pkg.percent != 0 ? pkg.percent : '-'}</p>
                    {this.renderPrice(pkg.usd)}
                </kc-package>
                <Suspense fallback={<div className='skeleton' />}>
                    <RadioGroup
                        name='package'
                        value={pkg.upc}
                        checked={pkg.upc == this.props.upc}
                        onChange={this.selectPackage}
                    />
                </Suspense>
            </column>
        );
    }

    renderPrice = (usd) => {
        if (usd.current != usd.original) {
            return [
                <h4 className='has-text-strikethrough'>${usd.original}</h4>,
                <h4 className='has-weight-700 has-text-sushi'>${usd.current}</h4>,
            ];
        }

        return (<h4>${usd.current}</h4>);
    }

    renderTotal = () => {
        const pkg = this.props.packages.find(pkg => pkg.upc == this.props.upc);

        if (pkg.usd.current != pkg.usd.original) {
            return [
                <h2 className='sale'>
                    ${pkg.usd.current}
                </h2>,
                <h3 className='sale'>${pkg.usd.original}</h3>,
            ];
        }

        return (<h2>${pkg.usd.current}</h2>);
    }

    selectPackage = (e, upc = null) => {
        upc = upc || e.target.value;
        this.props.update({ upc: upc });
    }

    purchase = (e) => {
        e.preventDefault();

        if (!this.props.submitting) {
            this.trackEvent();
            this.props.purchase();
        }
    }

    trackEvent = () => {
        let label = 'logged-out';

        if (this.props.logged_in) {
            label = this.props.voucher_upc == 'first-time-kc-package-offer'
                ? '1st-kc-package'
                : '2nd-or-more-kc-package';
        }

        this.props.trackEvent([ 'kc-store', 'Click', label, `KCStore:PurchaseCoinsButton-${this.props.upc}`]);
    }
}

const mapStateToProps = (state) => ({
    kc_sale: state['karmacoin-store'] && state['karmacoin-store'].kc_sale,
    logged_in: state.user && state.user.logged_in,
    packages: state['karmacoin-store'] && state['karmacoin-store'].packages,
    sale_message: state['karmacoin-store'].packages && state['karmacoin-store'].packages[0].message,
    submitting: state.product && state.product.submitting,
    upc: state['karmacoin-store'] && state['karmacoin-store'].upc,
    voucher_upc: state['karmacoin-store'].packages && state['karmacoin-store'].packages[0].voucher_upc,
});

const mapDispatchToProps = (dispatch) => ({
    purchase: () => dispatch({ type: 'karmacoin-store:purchase' }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    update: (payload) => dispatch({ type: 'karmacoin-store:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
